import { useEffect } from 'react';
import { sleep } from '../../utils/Sleep';
import { useDispatch } from 'react-redux';
import { hideNotificationFromApp, NotificationType } from '../../actions/NotificationsActions';
import { useWolfTracsState } from '../../hooks/redux/useWolfTracsState';

import './NotificationBlock.scss';

const NotificationBlock = () => {
    // Redux state
    const { show, message, notificationType } = useWolfTracsState(s => s.notifications.notification);
    // Access to redux dispatch
    const dispatch = useDispatch();

    // Logic for hiding the notification after a short time.
    // Note that this logic can be worked on. We've always had issues with notifications sliding in and out.
    // This I think is where that would need to change in the future.
    useEffect(() => {
        async function waitAndHideNotification() {
            await sleep(3000);
            hideNotification();
        }

        if(show) {
            waitAndHideNotification();
        }
    }, [show]);

    const hideNotification = () => {
        dispatch(hideNotificationFromApp());
    };
    
    const type = notificationType ? notificationType : NotificationType.Success;
    const header = type[0].toUpperCase() + type.slice(1);
    const classes = `notification alert alert-${type} ${show ? "slide-in" : "slide-out"}`;
    return (
        <div className={classes} role="alert">
            <button type="button" className="close" onClick={() => hideNotification()} aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="alert-heading">{header}</h4>
            <p>{message}</p>
        </div>
    ); 
};

export default NotificationBlock;